import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react"; // eslint-disable-next-line css-modules/no-unused-class

import styles from "./button.css";
var STYLE_TYPE_CLASSES = {
  primary: styles.primary,
  secondary: styles.secondary,
  tertiary: styles.tertiary,
  "temp-grey": styles.tempGrey
};

function disabledCB(event) {
  event.preventDefault();
}

/** BUTTONS FOR THE BUTTON GOD */
export function Button(_ref) {
  var _classnames;

  var className = _ref.className,
      element = _ref.element,
      fullHeight = _ref.fullHeight,
      fullWidth = _ref.fullWidth,
      openInNewTab = _ref.openInNewTab,
      styleType = _ref.styleType,
      props = _objectWithoutProperties(_ref, ["className", "element", "fullHeight", "fullWidth", "openInNewTab", "styleType"]);

  var Component = props.href ? "a" : "button";

  if (element) {
    Component = element;
  }

  var typeClass = STYLE_TYPE_CLASSES[styleType];

  if (!typeClass) {
    throw new Error("Unknown type ".concat(styleType, "!"));
  }

  var elementProps = props;
  elementProps.className = classnames(className, styles.button, typeClass, (_classnames = {}, _defineProperty(_classnames, styles.fullWidth, fullWidth), _defineProperty(_classnames, styles.fullHeight, fullHeight), _defineProperty(_classnames, styles.disabled, props.disabled), _defineProperty(_classnames, styles.buttonButton, !props.href), _classnames));

  if (props.href) {
    elementProps.target = openInNewTab ? "_blank" : "_self";
  }

  if (props.disabled) {
    elementProps.onClick = disabledCB;
  }

  return React.createElement(Component, elementProps);
}
export default Button;
Button.propTypes = {
  /** What goes in the button */
  children: PropTypes.node.isRequired,

  /** classname */
  className: PropTypes.string,

  /** Allows you to override what HTML element the button renders as */
  element: PropTypes.oneOf(["a", "button", "span"]),

  /** Prevent button being clickable (& visual state) */
  disabled: PropTypes.bool,

  /** Button grows horizontally to fit its container */
  fullWidth: PropTypes.bool,

  /** Button grows vertically to fit its container */
  fullHeight: PropTypes.bool,

  /** If this button should be a link, set this to where it should go */
  href: PropTypes.string,

  /** Event handler */
  onClick: PropTypes.func,

  /** If this button is a link, open in a _blank window */
  openInNewTab: PropTypes.bool,

  /** What style this button should show as */
  styleType: PropTypes.oneOf(["primary", "secondary", "tertiary", "temp-grey"]).isRequired
};